import { AxiosError } from 'axios';
import ExploreCategory from '../../domain/entities/ExploreCategory';
import ExploreCategoryArea from '../../domain/entities/ExploreCategoryArea';
import ExploreCategoryStation from '../../domain/entities/ExploreCategoryStation';
import ExploreTopContent from '../../domain/entities/ExploreTopContent';
import MerchantCategory from '../../domain/entities/MerchantCategory';
import { ExploresApi, newExploresApi } from '../api/backend/api';

interface CategoriesQuery {
  merchantCategoryIds?: number[];
  query?: string;
}

export class ExploreRepository {
  private api: ExploresApi;

  constructor(api: ExploresApi) {
    this.api = api;
  }

  public async TopContent(): Promise<ExploreTopContent> {
    return this.api
      .exploreTopContent()
      .then(res => {
        if (!res.data) {
          throw Error('Response Structure is invalid');
        }

        return new ExploreTopContent(res.data);
      })
      .catch((err: AxiosError) => {
        // TODO handle error by status
        return Promise.reject(err);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }

  public async Categories(
    query: CategoriesQuery = {},
  ): Promise<MerchantCategory[]> {
    return this.api
      .exploreCategories(query.query, query.merchantCategoryIds)
      .then(res => {
        if (!res.data.merchantCategories) {
          throw Error('Response Structure is invalid');
        }

        return res.data.merchantCategories.map(
          category => new MerchantCategory(category),
        );
      })
      .catch((err: AxiosError) => {
        // TODO handle error by status
        return Promise.reject(err);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }

  public async CategoryStation(
    categoryId: number,
    stationId: number,
    page: number,
  ): Promise<ExploreCategoryStation> {
    return this.api
      .exploreCategoryStation(categoryId, stationId, page)
      .then(res => {
        if (!res.data) {
          throw Error('Response Structure is invalid');
        }

        return new ExploreCategoryStation(res.data);
      })
      .catch((err: AxiosError) => {
        // TODO handle error by status
        return Promise.reject(err);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }

  public async CategoryArea(
    categoryId: number,
    areaId: number,
    page: number,
  ): Promise<ExploreCategoryArea> {
    return this.api
      .exploreCategoryArea(categoryId, areaId, page)
      .then(res => {
        if (!res.data) {
          throw Error('Response Structure is invalid');
        }

        return new ExploreCategoryArea(res.data);
      })
      .catch((err: AxiosError) => {
        // TODO handle error by status
        return Promise.reject(err);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }

  public async CategoriesById(
    categoryId: number,
    page: number,
  ): Promise<ExploreCategory> {
    return this.api
      .exploreCategoriesById(categoryId, page)
      .then(res => {
        if (!res.data) {
          throw Error('Response Structure is invalid');
        }

        return new ExploreCategory(res.data);
      })
      .catch((err: AxiosError) => {
        // TODO handle error by status
        return Promise.reject(err);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }
}

export default new ExploreRepository(newExploresApi());
